import { TaskResponse } from "@9amhealth/openapi";
import { AppointmentRatingState } from "src/state/AppointmentRatingCubit/AppointmentRatingCubit";
import { AppointmentRatingScreen } from "./AppointmentRatingScreen";

export const getAppointmentRatingScreen = ({
  isLoading,
  task
}: AppointmentRatingState): AppointmentRatingScreen => {
  if (isLoading) {
    return AppointmentRatingScreen.LOADING;
  }
  if (!task) {
    return AppointmentRatingScreen.ERROR;
  }
  switch (task.status) {
    case TaskResponse.status.COMPLETED:
      return AppointmentRatingScreen.ALREADY_RATED;
    case TaskResponse.status.AVAILABLE:
      return AppointmentRatingScreen.RATE_NOW;
    case TaskResponse.status.SKIPPED:
      return AppointmentRatingScreen.EXPIRED;
    default:
      return AppointmentRatingScreen.ERROR;
  }
};
